import { Link } from "react-router-dom";
import { MapPin, MessageCircle, CheckCircle2 } from "lucide-react";
import VerifiedBadge from "@/components/VerifiedBadge";
import SaveButton from "@/components/SaveButton";

const INTENT_STYLES = {
  need: { label: "I NEED", bg: "bg-[#C05A3D] text-white", accent: "border-l-[#C05A3D]" },
  have: { label: "I HAVE", bg: "bg-[#1E3A2F] text-[#DDA74A]", accent: "border-l-[#1E3A2F]" },
  offer: { label: "I OFFER", bg: "bg-[#DDA74A] text-[#1E3A2F]", accent: "border-l-[#DDA74A]" },
  know: { label: "I KNOW", bg: "bg-[#3B5A6B] text-white", accent: "border-l-[#3B5A6B]" },
};

export default function NeedCard({ need }) {
  const style = INTENT_STYLES[need.intent] || INTENT_STYLES.need;
  const resolved = need.status === "resolved";
  return (
    <div className="relative">
      <div className="absolute top-3 right-3 z-10">
        <SaveButton type="need" id={need.id} size="icon" />
      </div>
      <Link
        to={`/needs/${need.id}`}
        data-testid={`need-card-${need.id}`}
        className={`abm-card p-5 border-l-4 ${style.accent} flex flex-col fade-in ${resolved ? "opacity-70" : ""}`}
      >
      <div className="flex items-center justify-between gap-2">
        <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] uppercase tracking-widest font-semibold ${style.bg}`}>
          {style.label}
        </span>
        {resolved && (
          <span className="inline-flex items-center gap-1 text-xs text-[#1E3A2F] font-medium"><CheckCircle2 className="w-3.5 h-3.5" /> {need.resolution_type || "resolved"}</span>
        )}
      </div>
      <h3 className="font-display text-lg text-[#1A1A1A] mt-3 leading-tight line-clamp-2">{need.title}</h3>
      <p className="mt-2 text-sm text-[#5C5C5C] line-clamp-2">{need.description}</p>
      <div className="mt-4 flex items-center justify-between text-xs text-[#5C5C5C]">
        <span className="inline-flex items-center gap-1">
          <MapPin className="w-3 h-3" /> {need.location || "Washington"}
          {need.owner_verified && <VerifiedBadge tier={need.owner_verification_tier} size="sm" className="ml-2" />}
        </span>
        <span className="inline-flex items-center gap-1"><MessageCircle className="w-3 h-3" /> {need.recommendation_count || 0}</span>
      </div>
    </Link>
    </div>
  );
}
